module.exports = __webpack_public_path__ + "static/media/phones_promo_image.8f2ee26e.png";